const tables = ['cd_contract_status', 'cd_contract_type', 'cd_payment_status']
import batchLoad from 'global/common/batch-load'
const token = localStorage.getItem('token')
//if (token == null) throw new Error('Пользователь не авторизован');
import mapClassifier from 'global/common/mapClassifier'
export default {
    state: {
        contractLoaded: false,
        contractDict: Object.fromEntries(tables.map(row => [row, []])),
        config(ctx) {
            return {
                headers(row) {
                    return {
                        Authorization: token,
                        'Table-Type': row
                    }
                },
                onComplete({ row, response }) {
                    ctx.commit('setValue', { row, result: response.data.Data })
                },
                onError({ row, reason }) {
                    console.error(reason);
                },
                onBatchComplete(resolved) {
                    ctx.commit('changeContractLoadStatus', true)
                }
            }
        }
    },
    actions: {
        retrieve(ctx) {
            if (ctx.state.contractLoaded) return Promise.resolve(ctx.contractDict);
            return batchLoad(tables, (row) => `/${row}`, 50, ctx.state.config(ctx))
        }
    },
    mutations: {
        setValue(state, { row, result }) {
            state.contractDict[row] = result
        },
        changeContractLoadStatus(state, status) {
            state.contractLoaded = status
        },
    },
    getters: {
        ...mapClassifier(tables, 'contractDict'),
        getContractStatus(state) {
            return (contract_status_id) => {
                return state.contractDict.cd_contract_status.find(status => status.contract_status_id === contract_status_id)
            }
        },
        get_payment_status(state) {
            return ({ payment_status_id }) => state.contractDict.cd_payment_status.find(s => s.payment_status_id == payment_status_id)
        },
        get_contract_status(state) {
            return ({ contract_status_id }) => state.contractDict.cd_contract_status.find(s => s.contract_status_id == contract_status_id)
        },
        get_contract_type(state) {
            return ({ contract_type_id }) => state.contractDict.cd_contract_type.find(t => t.contracttypeid == contract_type_id)
        }
    }
}